import { render, staticRenderFns } from "./FollowInterestFilter.vue?vue&type=template&id=478e6b1c&"
import script from "./FollowInterestFilter.vue?vue&type=script&lang=js&"
export * from "./FollowInterestFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports